function baidu() {
  var _hmt = _hmt || [];
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?ee0790383454ac1124db906626d699de";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
}

export default{
    install: function (Vue) {
        Vue.prototype.$baidu = () => baidu()
    },
    baidu
}


// WEBPACK FOOTER //
// ./src/common/js/baidu.js